import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedBack from "../images/AnimatedBack.gif";
import AnimatedAR from "../images/AnimatedAR.gif";
import AnimatedAR1 from "../images/AnimatedAR1.gif";
import AR1 from "../images/AR1.png";
import AR2 from "../images/AR2.png";
import AR3 from "../images/AR3.png";
import AR4 from "../images/AR4.png";
import AR5 from "../images/AR5.png";
import AR6 from "../images/AR6.png";
import Process from "../components/Process";
import Customer from "../components/Customer";

function AR() {
  return (
    <>
      <Header />
      <div className="WebD">
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info">
            <p className="Webd-p">AR & VR Development</p>
            <p
              className="Webd-p"
              style={{ marginTop: "-10px", marginBottom: "10px" }}
            >
              Company
            </p>
            <p className="Webd-p1">
              Purohit Technosoft empowers your company to craft a dynamic web of
              digital experiences,seamlessly integrating Augmented Reality.
            </p>
          </div>
        </div>
        <div
  className="Webdesign-main1"
  style={{
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: "40px", // spacing between image & text
    padding: "40px 80px", // desktop padding
    maxWidth: "1200px",
    margin: "0 auto", // center the container
  }}
>
  {/* Image */}
  <img
    className="Webdesign-main1-img"
    src={AnimatedAR}
    alt=""
    style={{
      flex: "1 1 400px", // responsive width
      maxWidth: "500px",
      width: "100%",
      height: "auto",
      objectFit: "cover",
      borderRadius: "12px",
    }}
  />

  {/* Text Section */}
  <div
    className="Webdesign-info"
    style={{
      flex: "1 1 400px",
      fontSize: "18px",
      lineHeight: "1.6",
      padding: "0 20px", // safe padding for mobile
    }}
  >
    <p style={{ marginTop: "20px" }}>
      Purohit Technosoft takes pride in being a leading Augmented Reality
      Development company, dedicated to enhancing user experiences and adding
      value to businesses across industries. We specialize in designing AR
      solutions that seamlessly integrate immersive digital content with the
      real world, leveraging advanced technologies to ensure these experiences
      are both engaging and productive.
    </p>

    <p style={{ marginTop: "20px" }}>
      In the field of Virtual Reality Development, we excel at crafting
      immersive VR experiences with versatile functionalities. Our expert
      development and design teams work collaboratively with clients to deliver
      seamless performance across a wide range of hardware platforms, ensuring
      that the VR experiences we create are innovative, reliable, and tailored
      to meet your specific requirements.
    </p>
  </div>
</div>

        <img
  style={{
    display: "block",
    margin: "50px auto", // centers horizontally
    maxWidth: "1000px", // desktop max width
    width: "100%", // shrink on smaller screens
    padding: "0 20px", // side padding for mobile
    objectFit: "cover",
  }}
  src={AnimatedAR1}
  alt=""
/>

        <div
      className="Webd-main2"
      style={{
        padding: "40px 80px", // Desktop padding
        maxWidth: "1200px",
        margin: "0 auto", // Center content
      }}
    >
      {/* Heading */}
      <p
        className="Webd-main2-p"
        style={{
          textAlign: "center",
          fontSize: "28px",
          fontWeight: "bold",
          marginBottom: "20px",
        }}
      >
        AR & VR Services
      </p>

      {/* Intro text */}
      <p
        className="Webd-main2-p1"
        style={{
          margin: "20px auto",
          textAlign: "center",
          maxWidth: "900px",
          padding: "0 20px", // Safe padding for mobile
          fontSize: "16px",
          lineHeight: "1.6",
        }}
      >
        Purohit Technosoft has crafted exceptional Virtual Reality and
        Augmented Reality experiences, enabling our clients to deeply engage
        their audiences and end-users, creating lasting impressions and driving
        meaningful interactions.
      </p>

      {/* First row */}
      <div
        className="Webd-main2-boxes"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "30px",
          margin: "40px auto",
        }}
      >
        <div
          className="Webd-main2-box"
          style={{
            flex: "1 1 300px",
            maxWidth: "350px",
            padding: "20px",
            textAlign: "center",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={AR1}
            alt="VR World"
            style={{ width: "50px", height: "50px", borderRadius: "19px" }}
          />
          <p
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            VR WORLD
          </p>
          <p style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.6" }}>
            With Virtual Reality development, the only limit is your
            imagination. We create elevated, immersive experiences tailored
            to client requirements, enabling users to explore powerful,
            boundless visuals that transcend time and location.
          </p>
        </div>

        <div
          className="Webd-main2-box"
          style={{
            flex: "1 1 300px",
            maxWidth: "350px",
            padding: "20px",
            textAlign: "center",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={AR2}
            alt="Customising Experiences"
            style={{ width: "50px", height: "50px", borderRadius: "19px" }}
          />
          <p
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            Customising Experiences
          </p>
          <p style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.6" }}>
            The possibilities for customization with Augmented Reality
            development are limitless. Personalizing how customers interact
            with a product or service is key to maintaining intimacy at
            scale, creating engaging and tailored experiences for every user.
          </p>
        </div>

        <div
          className="Webd-main2-box"
          style={{
            flex: "1 1 300px",
            maxWidth: "350px",
            padding: "20px",
            textAlign: "center",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={AR3}
            alt="Details Count"
            style={{ width: "50px", height: "50px", borderRadius: "19px" }}
          />
          <p
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            Details Count
          </p>
          <p style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.6" }}>
            Virtual Reality walkthroughs enable detailed visualization of
            ideas without the need for physical mobility of products or people.
            With Virtual Reality Development, customers can thoroughly explore a
            product, gaining a complete understanding before making a purchase
            decision.
          </p>
        </div>
      </div>

      {/* Second row */}
      <div
        className="Webd-main2-boxes"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "30px",
          margin: "40px auto",
        }}
      >
        <div
          className="Webd-main2-box"
          style={{
            flex: "1 1 300px",
            maxWidth: "350px",
            padding: "20px",
            textAlign: "center",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={AR4}
            alt="Content Is King"
            style={{ width: "50px", height: "50px", borderRadius: "19px" }}
          />
          <p
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            Content Is King
          </p>
          <p style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.6" }}>
            Augmented Reality will remain a dominant force as long as people
            stay connected. AR enables the delivery of content in a highly
            immersive way, fostering greater trust and retention through
            enhanced engagement.
          </p>
        </div>

        <div
          className="Webd-main2-box"
          style={{
            flex: "1 1 300px",
            maxWidth: "350px",
            padding: "20px",
            textAlign: "center",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={AR5}
            alt="Today's Technology"
            style={{ width: "50px", height: "50px", borderRadius: "19px" }}
          />
          <p
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            Today's Technology
          </p>
          <p style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.6" }}>
            AR development is rapidly expanding globally, with its potential
            growing by the day. Market leaders like Google, Microsoft,
            Amazon, Apple, and Facebook are leveraging Augmented Reality to
            elevate their businesses and redefine industry standards.
          </p>
        </div>

        <div
          className="Webd-main2-box"
          style={{
            flex: "1 1 300px",
            maxWidth: "350px",
            padding: "20px",
            textAlign: "center",
            borderRadius: "12px",
            background: "#fff",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
        >
          <img
            src={AR6}
            alt="Save Time"
            style={{ width: "50px", height: "50px", borderRadius: "19px" }}
          />
          <p
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            Save Time
          </p>
          <p style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.6" }}>
            Advancements in Virtual Reality have made it possible to be
            virtually present anywhere in the world without the need for
            physical travel. This technology saves time and money for
            professionals across various industries by enabling remote
            collaboration, training, and client interactions.
          </p>
        </div>
      </div>
    </div>
      </div>
      <Process/>
      <Customer/>
      <Footer />
    </>
  );
}

export default AR;
